import { StepDrawer } from "@stepfinance/react";
import React from "react";

import { MenuItems } from "./MenuItems";

interface IProps {
  selectedMenuKey: string[] | undefined;
  onItemSelect: (item) => void;
}

export const MobileMenu: React.FC<IProps> = ({ onItemSelect, selectedMenuKey }) => {
  return (
    <StepDrawer>
      <MenuItems selectedMenuKey={selectedMenuKey} onItemSelect={onItemSelect} />
    </StepDrawer>
  );
};
